var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlechaHaciaAbajoParaNavegarBlanca(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99997 9.42016C5.7849 9.42016 5.56987 9.33804 5.4059 9.17415L0.24617 4.01437C-0.0820565 3.68614 -0.0820565 3.15398 0.24617 2.82589C0.574263 2.4978 1.10632 2.4978 1.43457 2.82589L5.99997 7.39155L10.5654 2.82605C10.8936 2.49795 11.4256 2.49795 11.7537 2.82605C12.0821 3.15414 12.0821 3.6863 11.7537 4.01453L6.59404 9.17431C6.42999 9.33823 6.21495 9.42016 5.99997 9.42016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaHaciaAbajoParaNavegarBlanca);
export default __webpack_public_path__ + "static/media/flecha-hacia-abajo-para-navegarBlanca.9247ad6d5f7d7623491f270b2b6aeb5d.svg";
export { ForwardRef as ReactComponent };